import { render, staticRenderFns } from "./CalculatedReference.vue?vue&type=template&id=b5335736&scoped=true&"
import script from "./CalculatedReference.vue?vue&type=script&setup=true&lang=js&"
export * from "./CalculatedReference.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CalculatedReference.vue?vue&type=style&index=0&id=b5335736&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5335736",
  null
  
)

export default component.exports